exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bankAccountList>.item-link>.item-content>.item-inner>.item-title-row>.item-title {\n  color: #12bcf1 !important;\n}\n.polsize {\n  font-size: 12px;\n}\n.icon-account-red-bank {\n  background-image: url(" + require("../../assets/static/images/banks.png") + ");\n}\n.icon-account-green-bank {\n  background-image: url(" + require("../../assets/static/images/account.png") + ");\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c21d6b4","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/bankAccounts/CMImportBankAccountReport.vue
// module id = 1524
// module chunks = 2